import { FormStatus } from '../../../../utils/state/initialStateFactory';
import { CreateActionParams } from '../actions';

export type PromptLogin = () => void;

export function createPromptLoginAction({
  getControllerState,
  context: { wixSdkAdapter, reportError },
}: CreateActionParams): PromptLogin {
  return async () => {
    const [, setState] = getControllerState();
    if (!wixSdkAdapter.isPreviewMode()) {
      try {
        setState({
          status: FormStatus.PROCESSING_USER_DETAILS,
        });
        await wixSdkAdapter.promptUserLogin();
      } catch (e) {
        setState({
          status: FormStatus.IDLE,
        });
        reportError(e);
      }
    }
  };
}
